// extracted by mini-css-extract-plugin
export default {"table":"TableTable_table__sILr1","descriptionPopover":"TableTable_descriptionPopover__0BUps"};